import {
  DataLayerGetter,
  GoogleAnalyticsEvent,
  GoogleAnalyticsEventKey,
  GoogleAnalyticsPageview,
  GtagClientGetter,
  GtagEventKey,
} from './types'

export function getGtagClientFromWindow(): ReturnType<GtagClientGetter> {
  return typeof window?.gtag === 'function' ? window.gtag : undefined
}

export function getDataLayerFromWindow(): ReturnType<DataLayerGetter> {
  return typeof window?.dataLayer?.push === 'function' ? window.dataLayer : undefined
}

export function gtagEventConfigFromEvent(
  event: GoogleAnalyticsEvent | GoogleAnalyticsPageview,
): Gtag.ControlParams | Gtag.EventParams | Gtag.CustomParams {
  const gtagEventConfig = {}
  for (const [eventContextKey, eventContextValue] of Object.entries(event)) {
    switch (eventContextKey) {
      case GoogleAnalyticsEventKey.ACTION:
        break
      case GoogleAnalyticsEventKey.CATEGORY:
        gtagEventConfig[GtagEventKey.CATEGORY] = eventContextValue
        break
      case GoogleAnalyticsEventKey.FIELDS:
        Object.assign(gtagEventConfig, eventContextValue)
        break
      case GoogleAnalyticsEventKey.LABEL:
        gtagEventConfig[GtagEventKey.LABEL] = eventContextValue
        break
      case GoogleAnalyticsEventKey.PATH:
        gtagEventConfig[GtagEventKey.PATH] = eventContextValue
        break
      case GoogleAnalyticsEventKey.TITLE:
        gtagEventConfig[GtagEventKey.TITLE] = eventContextValue
        break
      default:
        gtagEventConfig[eventContextKey] = eventContextValue
        break
    }
  }
  return gtagEventConfig
}
